"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
var react_1 = __importDefault(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var styles_1 = require("@material-ui/core/styles");
var core_1 = require("@material-ui/core");
var AddRounded_1 = __importDefault(require("@material-ui/icons/AddRounded"));
exports.useStyles = styles_1.makeStyles(function (theme) {
    return styles_1.createStyles({
        root: {
            position: 'relative',
            display: 'block',
            maxWidth: 180,
            width: '100%',
            padding: 0,
            borderRadius: 10,
            minHeight: 172,
            color: theme.palette.grey[300],
            boxShadow: theme.shadows[1],
            transition: theme.transitions.create(['box-shadow', 'border-color', 'color', 'background-color'], {
                duration: theme.transitions.duration.standard,
            }),
            '&:hover': {
                backgroundColor: theme.palette.background.paper,
                boxShadow: '0 20px 40px rgba(0, 0, 0, .2)',
                color: theme.palette.primary.light,
            },
        },
        icon: {
            fontSize: '126px',
            position: 'absolute',
            left: '50%',
            top: '40%',
            transform: 'translate(-50%, -50%)',
        },
        label: {
            color: theme.palette.text.secondary,
            position: 'absolute',
            bottom: 30,
            left: 0,
            right: 0,
            textAlign: 'center',
        },
    });
});
var AddStudyPlanButton = function (_a) {
    var classNameProp = _a.className, other = __rest(_a, ["className"]);
    var classes = exports.useStyles();
    return (react_1.default.createElement(core_1.ButtonBase, __assign({ className: clsx_1.default(classes.root, classNameProp) }, other),
        react_1.default.createElement(AddRounded_1.default, { className: classes.icon }),
        react_1.default.createElement(core_1.Typography, { className: classes.label }, "Create a study plan")));
};
exports.default = AddStudyPlanButton;
//# sourceMappingURL=AddStudyPlanButton.js.map